import Executive from '../../framework/rmi-util'
import { register } from '../../framework/rmi-server-util'
import {
	checkRebookingPriceDiff,
	generateRebookingToken,
	getRebookableOrderByToken,
	getRebookingAvailabilities,
	getRebookingJobStatus,
	submitRebooking,
} from './RebookingTechnical'
import type {
	AvailabilityDay,
	GenerateRebookingTokenResponse,
	PriceDiffRequestItem,
	PriceDiffResult,
	RebookableOrderResponse,
	RebookingJobStatusResponse,
	SubmitRebookingRequest,
	SubmitRebookingResult,
} from './types'

// RMI surface of the "Change Bookings" standalone app (MYS-7069).
// generateRebookingToken is machine-to-machine (called by PEAK with the MYS api key).
// All other methods are token-authenticated: they are whitelisted in server.ts and every
// call verifies the JWT itself (the token IS the auth, like the contract magic link).
export default class RebookingExecutive extends Executive {
	// the browser RMI client must never replay a submit on an empty 500 — it executed the rebooking
	// twice at PEAK (MYS-7377). The page shows a "reload and check the order" error instead.
	nonRetryableMethods = ['submitRebooking']

	initServer() {
	}

	// auth: dedicated REBOOKING_API_KEY, enforced by rebookingApiKeyMiddleware in server.ts
	// (PEAK gets only this key, not the generic MYS_API_KEY)
	// adminUserId/adminUsername are two FLAT args, not a nested object — see the comment on
	// the implementation for why (MYS-7258).
	async generateRebookingToken(installationId: string, orderIncrementId: string, adminUserId?: string | number, adminUsername?: string, skipRebookableItemsCheck = true): Promise<GenerateRebookingTokenResponse> {
		return await generateRebookingToken(installationId, orderIncrementId, adminUserId, adminUsername, skipRebookableItemsCheck)
	}

	async getRebookableOrderByToken(token: string): Promise<RebookableOrderResponse> {
		return await getRebookableOrderByToken(token)
	}

	async getRebookingAvailabilities(token: string, productId: string, from: string, until: string): Promise<AvailabilityDay[]> {
		return await getRebookingAvailabilities(token, productId, from, until)
	}

	async checkRebookingPriceDiff(token: string, items: PriceDiffRequestItem[]): Promise<PriceDiffResult[]> {
		return await checkRebookingPriceDiff(token, items)
	}

	// answers PENDING + jobId once the PEAK call has been handed to the background job (phase 2)
	async submitRebooking(token: string, request: SubmitRebookingRequest): Promise<SubmitRebookingResult> {
		return await submitRebooking(token, request)
	}

	// read: keeps the framework retry
	async getRebookingJobStatus(token: string, jobId: string): Promise<RebookingJobStatusResponse> {
		return await getRebookingJobStatus(token, jobId)
	}
}

register(RebookingExecutive)
